import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import "../componentCss/webform.css";
import Dashboardheader from "./dashboardheader";
import AssignedFormSidebar from "./assignedFormSidebar";
import "../componentCss/sidebar.css";
import {
  getPrescriptionAssignListAction
} from "../../Action/admin.action";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from './decrypt';
import propertise from "../../config/properties";
import MedicationsDrugList from './MedicationsDrugList'
import AncillaryDrugList from './AncillaryDrugList'

const patientMrnNumber = localStorage.getItem('patientMrnNumber');
const medPassDrugFormId = propertise.medPassDrugFormId
const ancillaryFormId = propertise.ancillaryFormId

const name = 'Prescription List'
const PrescriptionList = () => {
  const [medPassDrugAssignedList, setmedPassDrugAssignedList] = useState([]);
  const [ancillaryDrugAssignedList, setancillaryDrugAssignedList] = useState([]);
  const [prescriptionAssignedList, setPrescriptionAssignedList] = useState([]);

  useEffect(() => {
    if (patientMrnNumber) {
      getPrescriptionAssignListAPI()
    }
  }, []);

  let getPrescriptionAssignListAPI = async () => {
    let res = await getPrescriptionAssignListAction({ mrnNumber: patientMrnNumber });
    if (res.success) {
      let data = decryptData(res.data);
      setPrescriptionAssignedList(data);

      const medPassDrugData = data.filter(item => item.formId === medPassDrugFormId);
      const ancillaryData = data.filter(item => item.formId === ancillaryFormId);
      setmedPassDrugAssignedList(medPassDrugData)
      setancillaryDrugAssignedList(ancillaryData)
    }
  };

  return (
    <>
      <Dashboardheader />
      <div className="wrapper">
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              <Col lg={3} md={3} sm={3}> <div className="form-preview-container">
                <AssignedFormSidebar />
              </div></Col>
              <Col lg={9} md={9} sm={9}> <div className="form-preview-container" id="example-collapse-text">
                <h2>{name} Record Details</h2>
                <ul className="list-group">

                  <li className="list-group-item d-flex flex-row ">
                    <div className="w-50"><strong>MRN Number:</strong></div>
                    {prescriptionAssignedList.length > 0 ? prescriptionAssignedList[0].mrnNumber : ''}
                  </li>

                  <li className="list-group-item d-flex flex-row ">
                    <div className="w-50"><strong>Emirates ID Number:</strong></div>
                    {prescriptionAssignedList.length > 0 ? prescriptionAssignedList[0].emrNumber : ''}
                  </li>

                  <li className="list-group-item">
                    <Tabs defaultActiveKey="medications" id="drug-tabs" className="mb-3">
                      <Tab eventKey="medications" title="Medication Drugs">
                        <MedicationsDrugList medPassDrugAssignedList={medPassDrugAssignedList} getPrescriptionAssignListAPI={getPrescriptionAssignListAPI} />
                      </Tab>
                      <Tab eventKey="ancillary" title="Ancillary Drugs">
                        <AncillaryDrugList ancillaryDrugAssignedList={ancillaryDrugAssignedList} getPrescriptionAssignListAPI={getPrescriptionAssignListAPI}/>
                      </Tab>
                    </Tabs>
                  </li>
                </ul>
              </div></Col>
            </Row>
          </Container>
        </div>
      </div >
    </>
  );
};
export default PrescriptionList;